import { UploadData } from '../../../../store/uploadStore';
import { getUploadProgress } from '../helpers/uploadProgress';

export const getGlobalProgress = (currentUploads: UploadData[]) => {
  const currentProgress = currentUploads.reduce((acc, upload) => {
    return acc + getUploadProgress(upload);
  }, 0);
  const totalProgress = currentUploads.length * 100;

  return (currentProgress / totalProgress) * 100;
};
